const { LIST_CUSTOMER_ACCESS, ERROR_CUSTOMER_ACCESS } = require('../Constants/customerAccess.constants');

const initalState = {
    error: {
        code: '',
        message: ''
    },
    customerAccessData: [],
    count: 0,
    loadingCustomerAccess: true,
};

export default (state = initalState, action) => {
    switch (action.type) {
        case LIST_CUSTOMER_ACCESS:
            return {
                ...state,
                customerAccessData: action.data.customersList.map(
                    item => ({ ...item, supportTeamNames: item.supportTeam.map(st => st.name).join(',') })
                ),
                count: action.data.count,
                loadingCustomerAccess: false,
            };
        case ERROR_CUSTOMER_ACCESS:
            return {
                ...state,
                error: {
                    message: action.data,
                    code: action.code,
                    loadingCustomerAccess: false,
                }
            };
        default:
            return state;
    }
};
